// frontend/src/components/AdUnit.js
// Google AdSense ad unit placeholder
// Replace ADSENSE_CLIENT and ADSENSE_SLOT with real values after AdSense approval

import React, { useEffect } from 'react';

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-XXXXXXXXXXXXXXXXX';
const ADSENSE_ENABLED = process.env.REACT_APP_ADSENSE_ENABLED === 'true';
const ADSENSE_PLACEHOLDER_VISIBLE = process.env.REACT_APP_ADSENSE_PLACEHOLDER === 'true';

const AdUnit = ({ slot, format = 'auto', style = {}, className = '' }) => {
  useEffect(() => {
    if (ADSENSE_ENABLED && window.adsbygoogle) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.warn('AdSense push error:', e);
      }
    }
  }, []);

  if (!ADSENSE_ENABLED) {
    // Hidden by default — set REACT_APP_ADSENSE_PLACEHOLDER=true to show grey boxes
    if (!ADSENSE_PLACEHOLDER_VISIBLE) return null;
    return (
      <div
        className={`ad-unit-placeholder ${className}`}
        style={{
          background: '#f8f9fa',
          border: '1px dashed #dee2e6',
          borderRadius: '4px',
          padding: '12px',
          textAlign: 'center',
          color: '#aaa',
          fontSize: '12px',
          minHeight: '90px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style
        }}
      >
        📢 Ad Space
      </div>
    );
  }

  return (
    <ins
      className={`adsbygoogle ${className}`}
      style={{ display: 'block', ...style }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
};

export default AdUnit;
